import React, { useState } from "react";
import "./RecommendationEditForm.css";

function RecommendationEditForm({ recommendation, onClose, onSave }) {
  const [heading, setHeading] = useState(recommendation?.heading || "");
  const [text, setText] = useState(recommendation?.text || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!heading || !text) {
      alert("Both heading and text are required.");
      return;
    }
    onSave({ heading, text });
  };

  return (
    <div className="modal">
      <div className="modal-content">
        <button className="modal-close" onClick={onClose}>
          ×
        </button>
        <h3>Edit Recommendation</h3>
        <form onSubmit={handleSubmit}>
          <label>
            Recommendation ID:
            <input
              name="id"
              value={recommendation.id}
              disabled
              style={{ background: "#eee" }}
            />
          </label>
          <label>
            Recommendation Heading:
            <input
              name="heading"
              value={heading}
              onChange={(e) => setHeading(e.target.value)}
              required
              placeholder="Enter recommendation heading"
            />
          </label>
          <label>
            Recommendation Text:
            <textarea
              name="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              required
              rows={12}
              placeholder="Enter recommendation details"
            />
          </label>
          <div className="modal-buttons">
            <button className="blue-button" type="submit">
              Save
            </button>
            <button className="red-button" type="button" onClick={onClose}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default RecommendationEditForm;
